module.exports = __webpack_public_path__ + "img/collection-diamondJewelry070Carat.0db4a6c.jpg";